export default "__VITE_ASSET__0004add0__"